import { forwardRef, type Ref } from 'react';

import { Zoom, type ZoomProps } from '@mui/material';

export const PopupTransition = forwardRef(function Transition(
  properties: ZoomProps,
  reference: Ref<unknown>
) {
  return <Zoom ref={reference} timeout={150} {...properties} />;
});
